import React, { useEffect, useState } from 'react';
import {
  Button,
  CardMedia,
  Paper,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@mui/material';
import { Box } from '@mui/system';
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { useDispatch, useSelector } from 'react-redux';
import { rutas } from '../../rutas/rutas';
import { getCookie } from '../../utils/getCookie';
import fondo from '../../Web Mundo/Fondo_new_islas_lhtanv.png';
import axios from 'axios';
import { v4 as uuidv4 } from "uuid";
import { setInformacion } from '../../storage/slices/usuarios';

// Fallback para cualquier imagen ausente
const FALLBACK_IMG = 'https://via.placeholder.com/220x240?text=Item';

// ------- Catálogo base para que nunca desaparezcan aunque queden en 0 -------
const BASE_ITEMS = [
  {
    nombre: "General Pack",
    image:
      "https://res.cloudinary.com/druu0mcam/image/upload/v1719339873/Sobres_de_figuritas_rip5gr_dd2fd7_1_kyxwq0_psvtit.png",
    cantidad: 0,
  },
  {
    nombre: "Special Pack",
    image:
      "https://res.cloudinary.com/druu0mcam/image/upload/v1719339872/pack_special_cqkztw_1_ecp53e_qentqp.png",
    cantidad: 0,
  },
  {
    nombre: "LVL",
    image:
      "https://res.cloudinary.com/druu0mcam/image/upload/v1719350908/image_5_yyryo8.png",
    cantidad: 0,
  },
  {
    nombre: "Hueso Fusion",
    image:
      "https://res.cloudinary.com/druu0mcam/image/upload/v1719339529/HUESOOROANIMADO_wpjjpv_y5y9ih.gif",
    cantidad: 0,
  },
  // Si quieres que también permanezca:
  { nombre: "ticket stake",
    image:
    "https://www.bigdogbonegame.com/static/media/ticket-stake-brillo.ecb5844af3e158141cef.gif",
    cantidad: 0 },
];

// Mantiene items antiguos; si no vienen en la respuesta nueva, los deja con cantidad 0
const mergeConCeros = (prev = [], next = []) => {
  const byNamePrev = new Map((prev || []).map(i => [i?.nombre, i]));
  const byNameNext = new Map((next || []).map(i => [i?.nombre, i]));

  // actualiza/añade lo que vino nuevo
  for (const [nombre, itemNext] of byNameNext) {
    const prevItem = byNamePrev.get(nombre) || {};
    byNamePrev.set(nombre, { ...prevItem, ...itemNext });
  }

  // lo que existía antes y NO vino ahora -> se queda con cantidad 0
  for (const [nombre, itemPrev] of byNamePrev) {
    if (!byNameNext.has(nombre)) {
      byNamePrev.set(nombre, { ...itemPrev, cantidad: 0 });
    }
  }

  return Array.from(byNamePrev.values());
};

export const Inventario = () => {
  const { informacion } = useSelector(state => state.userSlice);

  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false); // mantenido a pedido
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();

  // Inventario local que preserva items en 0 si no vienen del backend
  const [articulos, setArticulos] = useState(() =>
    mergeConCeros(BASE_ITEMS, informacion?.inventario || [])
  );

  // Sincroniza cada vez que cambie el inventario en Redux
  useEffect(() => {
    setArticulos(prev => mergeConCeros(prev, informacion?.inventario || []));
  }, [informacion?.inventario]);

  // Resultados de sobres abiertos
  const [sobresAbierto, setSobresAbierto] = useState([]);

  // Diálogo para elegir cantidad a abrir
  const [qtyOpen, setQtyOpen] = useState(false);
  const [packSeleccionado, setPackSeleccionado] = useState(null);
  const [cantidadElegida, setCantidadElegida] = useState(1);
  const [abriendo, setAbriendo] = useState(false);

  const abrirDialogCantidad = (item) => {
    const stock = Number(item?.cantidad ?? 0);
    if (stock <= 0) return;
    setPackSeleccionado(item);
    setCantidadElegida(1);
    setQtyOpen(true);
  };
  const cerrarDialogCantidad = () => {
    setQtyOpen(false);
    setPackSeleccionado(null);
    setCantidadElegida(1);
  };

  // Ahora acepta cantidad
  const abrirSobres = (nombre, cantidad = 1) => {
    const tokenJWT = getCookie("token");
    const ruta = nombre.toLowerCase().includes('ticket') ? rutas.abrirTicket : rutas.abrirPack;

    setAbriendo(true);
    axios
      .post(
        ruta,
        { pack: nombre, user: informacion.nombre, cantidad }, // <-- enviamos cantidad
        { headers: { token: tokenJWT } }
      )
      .then((res) => {
        const data = res?.data || {};
        const cartas = Array.isArray(data?.carta)
          ? data.carta
          : Array.isArray(data?.cartas)
          ? data.cartas
          : [];

        if (cartas.length) {
          axios
            .get(`${rutas.getInformacion}`, { headers: { token: tokenJWT } })
            .then(res2 => {
              const inv = res2.data?.resultado?.inventario || [];
              setArticulos(prev => mergeConCeros(prev, inv));
              dispatch(setInformacion({ ...res2.data?.resultado }));
            });

          setSobresAbierto(cartas);
          handleOpen();
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setAbriendo(false));
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: 350, sm: "80%", md: "70%", lg: "60%", xl: "40%" },
    height: sobresAbierto.length < 4 ? "250px" : "450px",
    background: "#222730",
    border: "1px solid #000",
    // opacity: 0.1, // <- quitado para que el modal sea visible
    p: 4,
  };

  const onConfirmarCantidad = () => {
    const stock = Number(packSeleccionado?.cantidad ?? 0);
    const maxPermitido = Math.min(stock, 10);
    const n = Math.max(1, Math.min(maxPermitido, Number(cantidadElegida || 1)));
    cerrarDialogCantidad();
    abrirSobres(packSeleccionado?.nombre, n);
  };

  return (
    <Box
      sx={{
        backgroundImage: `url(${fondo})`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '95vh',
        backgroundPosition: 'bottom',
        backgroundSize: 'cover'
      }}
    >
      <Paper
        sx={{
          flexWrap: 'wrap',
          justifyContent: 'start',
          alignItems: 'start',
          display: 'flex',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          width: '90%',
          height: '100%'
        }}
      >
        {articulos?.length > 0
          ? articulos.map(item => {
              const stock = Number(item?.cantidad ?? 0);
              const isFusion = item?.nombre?.includes('Fusion');

              return (
                <Box
                  sx={{
                    flexDirection: 'column',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '220px',
                    height: '300px',
                    m: 1
                  }}
                  key={item?.nombre}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: '90%', height: '240px !important' }}
                    image={item?.image || FALLBACK_IMG}
                    alt={item?.nombre || 'Item'}
                  />
                  <Typography>{item?.nombre + ' - ' + stock}</Typography>

                  <Button
                    disabled={isFusion || stock <= 0 || abriendo}
                    onClick={() => !isFusion && abrirDialogCantidad(item)}
                    sx={{ width: '140px' }}
                    variant='contained'
                  >
                    {abriendo ? 'Opening...' : 'Open'}
                  </Button>
                </Box>
              );
            })
          : null}
      </Paper>

      {/* Modal de resultados (cartas abiertas) */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                border: "1px solid gray",
                display: "flex",
                flexWrap: "wrap",
                overflow: "auto",
                justifyContent: sobresAbierto.length < 4 ? "center" : "",
                alignItems: sobresAbierto.length < 4 ? "center" : "", // <- fix typo
                "&::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              {sobresAbierto.map((card) => {
                return (
                  <Box
                    sx={{
                      width: {
                        xs: "85px",
                        sm: sobresAbierto.length < 4 ? "150px" : "120px",
                      },
                      height: {
                        xs: "120px",
                        sm: sobresAbierto.length < 4 ? "220px" : "150px",
                      },
                      position: "relative",
                      margin: "5px",
                    }}
                    key={uuidv4()}
                    draggable="false"
                    className="animate__animated animate__fadeInUp"
                  >
                    <CardMedia
                      component="img"
                      image={card?.url || FALLBACK_IMG}
                      alt="Inicial"
                      sx={{
                        cursor: "pointer",
                        width: {
                          xs: "85px",
                          sm: sobresAbierto.length < 4 ? "150px" : "120px",
                        },
                        height: {
                          xs: "120px",
                          sm: sobresAbierto.length < 10 ? "220px" : "150px",
                        },
                        boxShadow: card?.brillante
                          ? "0px 0px 10px yellow"
                          : "none",
                        objectFit: "fill",
                      }}
                      onClick={() => {
                        //   setSelector(card);
                        //   setOpen2(true);
                      }}
                    />
                    {card?.item && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: "0",
                          left: "0",
                          background: 'rgba(0, 0, 0,0.5)',
                          width: "80px",
                          height: "35px",
                          borderRadius: "50%",
                          textAlign: "center",
                          color: "white",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {card?.item}
                      </Box>
                    )}
                    {card?.rareza && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: "0",
                          right: "0",
                          background: 'gray',
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          textAlign: "center",
                          color: "white",
                        }}
                      >
                        {card?.rareza}
                      </Box>
                    )}
                    {card?.cantidad && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: "0",
                          left: "0",
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          textAlign: "center",
                          color: "white",
                        }}
                      >
                        {card?.cantidad}
                      </Box>
                    )}
                  </Box>
                );
              })}
            </Box>
            <Typography
              id="transition-modal-title"
              variant="h6"
              component="h2"
            ></Typography>
          </Box>
        </Fade>
      </Modal>

      {/* Diálogo para elegir cantidad */}
      <Dialog open={qtyOpen} onClose={cerrarDialogCantidad}>
        <DialogTitle>Select the amount to open from 1 to a maximum of 10</DialogTitle>
        <DialogContent sx={{ pt: 1 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Disponibles: {Number(packSeleccionado?.cantidad ?? 0)}
          </Typography>
          <TextField
            type="number"
            fullWidth
            inputProps={{
              min: 1,
              max: Math.min(Number(packSeleccionado?.cantidad ?? 1), 10), // <- coherente con el backend
              step: 1
            }}
            value={cantidadElegida}
            onChange={(e) => setCantidadElegida(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={cerrarDialogCantidad}>Cancelar</Button>
          <Button
            variant="contained"
            onClick={onConfirmarCantidad}
            disabled={
              Number(cantidadElegida) < 1 ||
              Number(cantidadElegida) > Math.min(Number(packSeleccionado?.cantidad ?? 0), 10) // <- coherente con el backend
            }
          >
            Abrir
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
